// FLAGS: health-data
// The logged-in expert's own sessions with their client names; filters and page persist in storage.
// Lists 1:1 consults and the private spaces the expert hosts in one chronological table.
import { useState } from "react";
import {
  getFiltersFromStorage,
  removeFiltersFromStorage,
  saveFiltersToStorage,
} from "@src/utils/helpers";
import {
  SessionFilters,
  SessionsFilter,
} from "@src/components/SessionFilters/SessionFilters";
import { ModelsConsultStatus } from "@src/api/v1/data-contracts";
import { useTranslation } from "react-i18next";
import { useMySessionsRows } from "@src/views/MySessions/useMySessionsRows";
import SessionsView from "@src/views/SessionsView";

const columns = [
  {
    id: "MySessions.DateTime",
    width: 100,
  },
  {
    id: "",
    width: 25,
  },
  {
    id: "MySessions.ClientName",
    minWidth: 200,
  },
  {
    id: "MySessions.Session",
    minWidth: 116,
  },
  {
    id: "",
    width: 55,
  },
  {
    id: "MySessions.Type",
    minWidth: 125,
  },
  {
    id: "MySessions.Status",
    width: 110,
  },
  {
    id: "Common.Actions",
    minWidth: 80,
  },
];

const MySessionsView = () => {
  const { t } = useTranslation();
  const storeFiltersKey = "my-sessions";
  const defaultFilters = {
    status: ModelsConsultStatus.Scheduled,
    searchTerm: "",
    startedAtFrom: undefined,
    startedAtTo: undefined,
  };
  const { filters: storedFilters, page: storedPage } = getFiltersFromStorage(
    storeFiltersKey,
  ) ?? {
    filters: defaultFilters,
    page: 0,
  };
  const [filters, setFilters] = useState<SessionsFilter>(storedFilters);
  const [page, setPage] = useState(storedPage);

  const { rows, total, hasNextPage, isFetching, privateSpaceJoin } =
    useMySessionsRows(filters, page);

  return (
    <>
      <SessionFilters
        searchPlaceholder={t("MySession.List.SearchPlaceholder")}
        filters={filters}
        onFilterChanged={(f) => {
          saveFiltersToStorage(storeFiltersKey, f, 0);
          setPage(0);
          setFilters(f);
        }}
        onFilterCleared={() => {
          removeFiltersFromStorage(storeFiltersKey);
          setPage(0);
          setFilters(defaultFilters);
        }}
        showExpertFilter={false}
      />
      <SessionsView
        titleText={t("MySessions.PageTitle")}
        page={page}
        onPageChange={(p: number) => {
          saveFiltersToStorage(storeFiltersKey, filters, p);
          setPage(p);
        }}
        columns={columns}
        isFetching={isFetching}
        rows={rows}
        privateSpaceJoin={privateSpaceJoin}
        total={total}
        hasNextPage={hasNextPage}
        showCopyJoinLink
        showReferralToolkitIcon
        showSessionLanguage
        showCancelSessionInMenu
        showSessionStage
      />
    </>
  );
};

export default MySessionsView;
